<template>
  <div class="basic-ads-campaigns-list">
    <Card>
      <h4 class="basic-ads-campaigns-list__title">
        {{ $t('ADVERTISEMENT.CAMPAIGNS_LIST.BASIC.TITLE') }}
      </h4>
      <div class="row align-justify">
        <div class="columns large-3 medium-6 small-12">
          <RangeFilter
            v-model="rangeFilter"
            :default-filters="campaignRangeFilters"
            @input="onRangeChange"
          />
        </div>
      </div>
      <CardApiError
        v-if="apiError"
        wrapper-class="campaigns__error-wrapper"
        :error-text="$t('ADVERTISEMENT.CAMPAIGNS.API_ERROR')"
        @retry="getCampaigns"
      />
      <WithManualPagination
        v-else
        :show-pagination="Boolean(campaigns.length) && !isLoading"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        @size-change="setPageSize"
        @current-change="setCurrentPage"
      >
        <div v-loading="isLoading" class="table-responsive">
          <CampaignsList :is-loading="isLoading" :campaigns="campaigns" />
        </div>
      </WithManualPagination>
    </Card>
  </div>
</template>

<script>
import Card from '@@/common/Card';
import CardApiError from '@@/common/CardApiError';
import RangeFilter from '@@/common/RangeFilter';
import statsFilter from '@/mixins/statsFilter';
import CampaignsList from './CampaignsList';
import WithManualPagination from '@@/common/paginations/WithManualPagination';
import { campaignTypes } from '../common/constants';

import { BasicAdsCampaigns } from '@/api/api';

export default {
  components: {
    Card,
    RangeFilter,
    CardApiError,
    CampaignsList,
    WithManualPagination,
  },
  mixins: [statsFilter],
  props: {
    updateController: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rangeFilter: 'all-time',
      isLoading: false,
      campaigns: [],
      apiError: false,
      pageSize: 10,
      total: 0,
      currentPage: 1,
    };
  },
  computed: {
    campaignRangeFilters() {
      return [
        {
          value: 'all-time',
          label: this.$t('ALL'),
        },
        ...this.getStatsRangeFilters(),
      ];
    },
  },
  watch: {
    currentPage() {
      this.getCampaigns();
    },
    pageSize() {
      this.getCampaigns();
    },
  },
  mounted() {
    this.getCampaigns();
    this.updateController.onUpdate(this.checkAndGetCampaigns);
  },
  beforeDestroy() {
    this.updateController.removeOnUpdate(this.checkAndGetCampaigns);
  },
  methods: {
    checkAndGetCampaigns(campaignType) {
      if (campaignType === campaignTypes.BASIC) this.getCampaigns();
    },
    setPageSize(pageSize) {
      this.pageSize = pageSize;
    },
    setCurrentPage(page) {
      this.currentPage = page;
    },
    onRangeChange() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.getCampaigns();
    },
    getCampaigns() {
      this.isLoading = true;
      this.apiError = false;

      return BasicAdsCampaigns.getCampaigns({
        range: this.rangeFilter,
        page: this.currentPage,
        pageSize: this.pageSize,
      })
        .then(({ data, numPages, total }) => {
          this.campaigns = data;
          this.numPages = numPages;
          this.total = total;
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
          this.apiError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.basic-ads-campaigns-list {
  &__title {
    margin-bottom: $global-margin * 1.5;
  }
}
</style>
